export default __webpack_public_path__ + "static/media/object-group.5b1364dd.svg";